<template>
  <v-app>
    <v-main>
      <nav class="tw-px-6 tw-py-8 tw-mx-auto tw-w-full tw-bg-violet-400">
        <div class="tw-mx-12">
          <router-link to="/" class="tw-mx-4 tw-no-underline tw-text-violet-50"
            >Home</router-link
          >
          <router-link
            v-if="isSignedIn"
            to="/upload"
            class="tw-mx-4 tw-no-underline tw-text-violet-50"
            >Upload</router-link
          >
          <router-link
            v-if="isSignedIn"
            to="/table"
            class="tw-mx-4 tw-no-underline tw-text-violet-50"
            >Table</router-link
          >
          <router-link
            v-if="isSignedIn"
            to="/trend"
            class="tw-mx-4 tw-no-underline tw-text-violet-50"
          >
            Trend
          </router-link>
          <v-btn
            @click="googleSignOut"
            class="tw-float-right tw-text-violet-50"
            size="small"
            elevation="2"
            variant="text"
            v-if="isSignedIn"
            >Sign Out</v-btn
          >
        </div>
      </nav>
      <router-view />
    </v-main>
  </v-app>
</template>
<script lang="ts">
import {
  browserSessionPersistence,
  getAuth,
  onAuthStateChanged,
  setPersistence,
  signOut,
} from "firebase/auth";
import { defineComponent, ref } from "vue";
import router from "./router";
import type { RouteLocationNormalized, NavigationGuardNext } from "vue-router";

export default defineComponent({
  name: "App",
  setup() {
    const auth = getAuth();
    const isSignedIn = ref<Boolean>(false);
    setPersistence(auth, browserSessionPersistence);
    onAuthStateChanged(auth, (user: any) => {
      isSignedIn.value = user;
    });

    const googleSignOut = () => {
      signOut(auth)
        .then(() => {
          router.push("/");
        })
        .catch((error) => {
          console.error(error);
          alert("Something went wrong");
        });
    };

    router.beforeEach(
      (
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
      ) => {
        if (to.path === "/") {
          next();
        } else {
          onAuthStateChanged(auth, (user: any) => {
            isSignedIn.value = user;
            if (isSignedIn.value) {
              next();
            } else {
              next("/");
            }
          });
        }
      }
    );
    return { isSignedIn, googleSignOut };
  },
});
</script>
